/**
 * MT Product Stick - 产品粘性栏功能
 * 修复版：增强了按钮查找逻辑，确保能触发加入购物车
 */

(function() {
  'use strict';

  function initProductStick(config) {
    const {
      mainFormSelector,
      submitButtonSelector,
      quantityInputSelector,
      sourceImageSelector,
      stickyButtonId,
      buyNowLinkId,
      productFormId,
      defaultVariantId,
      defaultImageUrl,
      cartUrl,
      currencyCode,
      productFormIdForPicker
    } = config;

    // 主表单（必须配置）
    const mainForm = document.querySelector(mainFormSelector);
    if (!mainForm) {
      console.error('MT ATC: 找不到主表单 (Main form not found):', mainFormSelector);
    }

    // Sticky bar按钮和元素
    const stickyButton = document.querySelector(stickyButtonId);
    const buyNowLink = document.querySelector(buyNowLinkId);
    const priceElement = document.querySelector('.mt-product-current-price');
    const comparePriceElement = document.querySelector('.mt-product-compare-price');
    const productImage = document.querySelector('.mt-product-stick-img');

    // 获取主表单中的数量输入字段
    function getQuantityInput() {
      if (!quantityInputSelector) return null;
      // 优先找全局
      let customInput = document.querySelector(quantityInputSelector);
      if (customInput) return customInput;
      // 其次找表单内
      if (mainForm) {
        return mainForm.querySelector(quantityInputSelector);
      }
      return null;
    }

    // 获取当前数量
    function getCurrentQuantity() {
      const quantityInput = getQuantityInput();
      if (quantityInput && quantityInput.value) {
        const quantity = parseInt(quantityInput.value, 10);
        return isNaN(quantity) || quantity < 1 ? 1 : quantity;
      }
      return 1;
    }

    /**
     * 核心修复：触发主表单提交
     * 增加了智能查找按钮的逻辑
     */
    function triggerMainFormSubmit() {
      // 1. 同步 Variant ID
      let mainVariantInput = null;
      if (mainForm) {
        mainVariantInput = mainForm.querySelector('input[name="id"]');
      }

      // 如果找不到现有的 input name="id"，尝试从 Picker 获取并创建一个
      if (!mainVariantInput || !mainVariantInput.value) {
        const variant = getCurrentVariantFromPicker();
        const targetId = (variant && variant.id) ? variant.id : defaultVariantId;
        
        if (targetId) {
          if (!mainVariantInput && mainForm) {
            mainVariantInput = document.createElement('input');
            mainVariantInput.type = 'hidden';
            mainVariantInput.name = 'id';
            mainForm.appendChild(mainVariantInput);
          }
          if (mainVariantInput) {
             mainVariantInput.value = targetId;
             updateVariantId(targetId);
          }
        }
      }

      if (mainVariantInput && mainVariantInput.disabled) {
        mainVariantInput.disabled = false;
      }

      // 2. 同步数量
      const mainQuantityInput = getQuantityInput();
      if (mainQuantityInput) {
        const qty = getCurrentQuantity();
        mainQuantityInput.value = qty;
        // 触发事件以通知主题 JS 更新
        mainQuantityInput.dispatchEvent(new Event('input', { bubbles: true }));
        mainQuantityInput.dispatchEvent(new Event('change', { bubbles: true }));
      }

      // 3. 查找并点击提交按钮 (重点修复部分)
      let mainSubmitButton = null;

      // 尝试 A: 根据配置的选择器查找
      if (submitButtonSelector) {
        mainSubmitButton = document.querySelector(submitButtonSelector);
      }

      // 尝试 B: 如果配置的选择器找到了 FORM 元素而不是 BUTTON，则在内部查找按钮
      if (mainSubmitButton && mainSubmitButton.tagName === 'FORM') {
        console.warn('MT ATC: 选择器指向了 Form 而不是 Button，正在尝试查找内部按钮...');
        mainSubmitButton = mainSubmitButton.querySelector('button[name="add"], button[type="submit"], input[type="submit"]');
      }

      // 尝试 C: 如果还没找到，且有 mainForm，在 mainForm 里找常见的按钮特征
      if (!mainSubmitButton && mainForm) {
        mainSubmitButton = mainForm.querySelector('button[name="add"]') || 
                           mainForm.querySelector('button[type="submit"]') ||
                           mainForm.querySelector('.product-form__submit');
      }

      // 执行点击
      if (mainSubmitButton) {
        if (mainSubmitButton.disabled) {
           console.warn('MT ATC: 原始加入购物车按钮处于禁用状态');
           // 尝试临时启用并点击（可选，视具体主题逻辑而定）
           // mainSubmitButton.disabled = false; 
        }
        mainSubmitButton.click();
      } else {
        console.error('MT ATC: 无法找到主加入购物车按钮，请检查配置。选择器为:', submitButtonSelector);
        
        // 兜底方案：如果实在找不到按钮但有表单，尝试直接提交表单（可能不会触发抽屉购物车，而是直接跳转）
        if (mainForm) {
           console.log('MT ATC: 尝试直接提交表单');
           mainForm.submit();
        }
      }
    }

    // 更新Buy Now链接的函数
    function updateBuyNowLink(variantId) {
      if (buyNowLink && variantId) {
        const quantity = getCurrentQuantity();
        buyNowLink.href = cartUrl + '/' + variantId + ':' + quantity + '?checkout';
      }
    }

    // 格式化价格的辅助函数
    function formatMoney(cents) {
      if (!cents) return '';
      if (window.themeVariables && window.themeVariables.settings.moneyFormat) {
        const format = window.themeVariables.settings.moneyFormat;
        const amount = (cents / 100).toFixed(2);
        return format.replace(/\{\{\s*amount\s*\}\}/, amount);
      }
      const amount = cents / 100;
      return new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: currencyCode || 'USD'
      }).format(amount);
    }

    // 更新价格的函数
    function updatePrice(variant) {
      if (variant) {
        if (priceElement && variant.price) {
          priceElement.textContent = formatMoney(variant.price);
        }
        if (comparePriceElement) {
          if (variant.compare_at_price && variant.compare_at_price > variant.price) {
            comparePriceElement.textContent = formatMoney(variant.compare_at_price);
            comparePriceElement.style.display = '';
          } else {
            comparePriceElement.style.display = 'none';
          }
        }
        if (productImage) {
          let imageUrl = null;
          if (variant.featured_media && variant.featured_media.preview_image) {
            imageUrl = variant.featured_media.preview_image.src || variant.featured_media.preview_image.url;
          } else if (variant.featured_image) {
            imageUrl = typeof variant.featured_image === 'string' ? variant.featured_image : variant.featured_image.src || variant.featured_image.url;
          } else if (variant.image) {
            imageUrl = typeof variant.image === 'string' ? variant.image : variant.image.src || variant.image.url;
          }

          if (imageUrl) {
            if (imageUrl.startsWith('//')) imageUrl = window.location.protocol + imageUrl;
            productImage.src = imageUrl;
            productImage.onerror = function() {
              if (defaultImageUrl && this.src !== defaultImageUrl) this.src = defaultImageUrl;
            };
          }
        }
      }
    }

    // 从variant-picker中获取当前选中的variant数据
    function getCurrentVariantFromPicker() {
      const variantPicker = document.querySelector('variant-picker[form-id="' + productFormIdForPicker + '"]');
      if (variantPicker) {
        const variantScript = variantPicker.querySelector('script[data-variant]');
        if (variantScript) {
          try {
            return JSON.parse(variantScript.textContent);
          } catch (e) {
            console.error('Error parsing variant data:', e);
          }
        }
      }
      return null;
    }

    function getVariantFromPicker(variantId) {
      const variant = getCurrentVariantFromPicker();
      if (variant && variant.id == variantId) return variant;
      return null;
    }

    function getMainFormVariantInput() {
      if (mainForm) return mainForm.querySelector('input[name="id"]');
      return null;
    }

    function updateVariantId(variantId) {
      const mainVariantInput = getMainFormVariantInput();
      if (mainVariantInput) {
        mainVariantInput.value = variantId;
        if (mainVariantInput.disabled) mainVariantInput.disabled = false;
        mainVariantInput.dispatchEvent(new Event('change', { bubbles: true }));
      }
    }

    // 监听variant变化事件
    if (mainForm) {
      mainForm.addEventListener('variant:change', function(event) {
        const variant = event.detail?.variant;
        if (variant && variant.id) {
          updateVariantId(variant.id);
          setTimeout(() => updateBuyNowLink(variant.id), 50);
          updatePrice(variant);
        }
      });

      const mainVariantInput = getMainFormVariantInput();
      if (mainVariantInput) {
        mainVariantInput.addEventListener('change', function() {
          const variantId = this.value;
          if (variantId) {
            setTimeout(() => updateBuyNowLink(variantId), 50);
            const variant = getCurrentVariantFromPicker();
            if (variant && variant.id == variantId) {
              updatePrice(variant);
            } else {
              const v = getVariantFromPicker(variantId);
              if (v) updatePrice(v);
            }
          }
        });
      }

      const quantityInput = getQuantityInput();
      if (quantityInput) {
        const updateBuyNowFromQuantity = function() {
          const currentVariantInput = getMainFormVariantInput();
          if (currentVariantInput && currentVariantInput.value) {
            updateBuyNowLink(currentVariantInput.value);
          }
        };
        quantityInput.addEventListener('change', updateBuyNowFromQuantity);
        quantityInput.addEventListener('input', updateBuyNowFromQuantity);
      }
    }

    if (stickyButton) {
      stickyButton.addEventListener('click', function(e) {
        e.preventDefault();
        e.stopPropagation();
        triggerMainFormSubmit();
      });
    }

    // 图片同步相关
    let lastSyncedSrc = '';
    function syncImageFromSource() {
      const currentSourceImage = document.querySelector(sourceImageSelector);
      if (currentSourceImage && productImage) {
        let currentSrc = currentSourceImage.src ||
                        currentSourceImage.getAttribute('src') ||
                        currentSourceImage.getAttribute('data-src') ||
                        (currentSourceImage.querySelector && currentSourceImage.querySelector('img')?.src);

        if (!currentSrc && currentSourceImage.srcset) {
          currentSrc = currentSourceImage.srcset.split(',')[0].trim().split(' ')[0];
        }

        if (currentSrc && currentSrc !== lastSyncedSrc && productImage.src !== currentSrc) {
          productImage.src = currentSrc;
          lastSyncedSrc = currentSrc;
        }
      }
    }

    function setupSourceImageListener() {
      const currentSourceImage = document.querySelector(sourceImageSelector);
      if (!currentSourceImage) {
        setTimeout(setupSourceImageListener, 500); 
        return;
      }
      
      syncImageFromSource();
      const imageObserver = new MutationObserver((mutations) => {
          let shouldSync = false;
          mutations.forEach((m) => {
             if(m.type === 'attributes' || m.type === 'childList') shouldSync = true;
          });
          if(shouldSync) setTimeout(syncImageFromSource, 50);
      });
      
      imageObserver.observe(currentSourceImage, { attributes: true, attributeFilter: ['src', 'srcset', 'data-src'], childList: true, subtree: true });
      
      // 定时检查以防万一
      setInterval(syncImageFromSource, 1000);
    }
    
    // 延迟初始化图片监听，确保DOM加载
    if(sourceImageSelector) setTimeout(setupSourceImageListener, 100);


    // 初始化Buy Now链接和价格
    function initializeStickyBar() {
      const mainVariantInput = getMainFormVariantInput();
      if (mainVariantInput && mainVariantInput.value) {
        updateBuyNowLink(mainVariantInput.value);
        const variant = getCurrentVariantFromPicker();
        if (variant && variant.id == mainVariantInput.value) updatePrice(variant);
      } else {
        let variant = getCurrentVariantFromPicker();
        if (variant && variant.id) {
          updateVariantId(variant.id);
          updateBuyNowLink(variant.id);
          updatePrice(variant);
        } else if (defaultVariantId) {
             updateVariantId(defaultVariantId);
             updateBuyNowLink(defaultVariantId);
        }
      }
    }

    initializeStickyBar();
    setTimeout(initializeStickyBar, 500);
  }

  // 显示/隐藏逻辑
  function initProductStickVisibility(config) {
    const { disappearClass } = config;
    const customProductPrice = document.querySelector(disappearClass ? '.' + disappearClass : '');
    const footerEl = document.querySelector('footer');
    const productStick = document.querySelector('.mt-product-stick');

    if (!productStick) return;

    let priceElementVisible = false;
    let footerVisible = false;

    function updateProductStickVisibility() {
      if (priceElementVisible || footerVisible) {
        productStick.classList.add('is-hidden');
      } else {
        productStick.classList.remove('is-hidden');
      }
    }

    if (customProductPrice) {
      const priceIO = new IntersectionObserver((entries) => {
          priceElementVisible = entries[0] && entries[0].isIntersecting;
          updateProductStickVisibility();
      });
      priceIO.observe(customProductPrice);
    }

    if (footerEl) {
      const footerIO = new IntersectionObserver((entries) => {
          footerVisible = entries[0] && entries[0].isIntersecting;
          updateProductStickVisibility();
      });
      footerIO.observe(footerEl);
    }
  }

  window.MTProductStick = {
    init: initProductStick,
    initVisibility: initProductStickVisibility
  };
})();